import { STATEMENTS_OF_WORK_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/statements_of_work_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator(['associatedStatementsOfWork']);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
